import React from 'react'
import { Col, Collapse } from 'antd';
import LessonPlanPage from './LessonPlanPage';

const { Panel } = Collapse;

function callback(key) {
  //console.log(key);
}

function LessonPlanCard(props) {
    const {data} = props || []
  return (
    <Col span={24}><Collapse defaultActiveKey={['1']} onChange={callback}>
        {
            data.map((prop, ind)=>{
                let {tname} = prop || ''
                return <Panel header={tname} style={{width:'100%'}} key={ind}>
                    <LessonPlanPage data={prop} />
                </Panel>
            })
        }
  </Collapse>
  </Col>
  )
}

export default LessonPlanCard
